export const InfluencerDocument = {
  upload:{
    url: "/partner/upload/influencer/document",
    method: ["POST"]
  },
  get:{
    url:"partner/document",
    method: ["GET"]
  },
  delete:{
    url:"/partner/delete/influencer/document",
    method: ["POST"]
  },

  putDocumentStatus:{
    url: "/partner/document/status",
    method: ["PUT"]
  },
  getDocumentStatus:{
    url: "/partner/document/status",
    method: ["GET"]
  }

}